import {
  BatchLoadExperimentsData,
  BatchLoadExperimentsDTO,
} from 'business/models/Models';
import React from 'react';

export enum EBatchloadDirectoryType {
  FOLDER = 'Folder',
  SUBFOLDER = 'SubFolder',
  PROJECT = 'Project',
}

type BatchLoadExperimentWizard = {
  setNextButtonDisallowed: (val: boolean) => void;
  batchLoadExperimentsDTO: BatchLoadExperimentsDTO | undefined;
  setBatchLoadExperimentsDTO: (val: BatchLoadExperimentsDTO) => void;
  fileName: string;
  setFileName: (val: string) => void;
  fileSize: string;
  setFileSize: (val: string) => void;
  selectedStatus: number;
  setSelectedStatus: (val: number) => void;
  expNameFormatString: string;
  setExpNameFormatString: (val: string) => void;
  experimentData: BatchLoadExperimentsData[];
  setExperimentData: (val: BatchLoadExperimentsData[]) => void;
  folderHierarchyOrder: EBatchloadDirectoryType[];
  setFolderHierarchyOrder: (val: EBatchloadDirectoryType[]) => void;
};

const BatchLoadExperimentWizardContext = React.createContext<BatchLoadExperimentWizard>({
  setNextButtonDisallowed: (val) => {},
  batchLoadExperimentsDTO: undefined,
  setBatchLoadExperimentsDTO: (val) => {},
  fileName: '',
  setFileName: (val) => {},
  fileSize: '',
  setFileSize: (val) => {},
  selectedStatus: 0,
  setSelectedStatus: (val) => {},
  expNameFormatString: '',
  setExpNameFormatString: (val) => {},
  experimentData: [],
  setExperimentData: (val) => {},
  folderHierarchyOrder: [
    EBatchloadDirectoryType.FOLDER,
    EBatchloadDirectoryType.PROJECT,
    EBatchloadDirectoryType.SUBFOLDER,
  ],
  setFolderHierarchyOrder: (val) => {},
});

export default BatchLoadExperimentWizardContext;
